import { inject, Injectable } from '@angular/core';
import { SubscriberSettingsResponseDto } from './subscriber-settings.model';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SubscriberSettingsService {
    private httpClient = inject(HttpClient);

    get(subscriberKey: number): Observable<SubscriberSettingsResponseDto> {
        return this.httpClient.get<SubscriberSettingsResponseDto>(`api/subscriber/${subscriberKey}/subscriber-settings`);
    }

    getFiscalYearStartMonth(subscriberKey: number): Observable<number> {
        return this.get(subscriberKey).pipe(map((s) => s.fiscalYearStartMonth));
    }
}
